import { useRef } from 'react';

/**
 * Genera un ID aleatorio usando Math.random
 * @returns {string} ID aleatorio con prefijo 'conekta-cards-container-'
 */
function generateId() {
  const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  return `conekta-cards-container-${randomId}`;
}

/**
 * Hook que genera un ID aleatorio que se mantiene entre renders
 * El ID se genera una sola vez y no cambia durante el ciclo de vida del componente
 * @returns {string} ID aleatorio persistente con prefijo 'conekta-cards-container-'
 */
export const useInstanceId = () => {
  const idRef = useRef(null);

  // Generar el ID solo si no existe (lazy initialization)
  if (idRef.current === null) {
    idRef.current = generateId();
  }

  return idRef.current;
};

